import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EdgeGroupId } from '@/react/portainer/environments/types';

export type Info = {
  HasLocalTimeZone: boolean;
  HasNoLocalTimeZone: boolean;
  MinAgentVersion: string;
  UpToDateCount: number;
  OutdatedCount: number;
};

export function useInfo(edgeGroupIds: EdgeGroupId[]) {
  return useQuery({
    queryKey: ['edge_update_schedules', 'info'] as const,
    queryFn: () => getInfo(edgeGroupIds),
    enabled: edgeGroupIds.length > 0,
  });
}

async function getInfo(edgeGroupIds: EdgeGroupId[]) {
  try {
    const { data } = await axios.get<Info>('/edge_update_schedules/info', {
      params: { edgeGroupIds },
    });
    return data;
  } catch (err) {
    throw parseAxiosError(err, 'Unable to retrieve creation info');
  }
}
